export function capitalizeFirstChar(str) {
    try {
        return str.charAt(0).toUpperCase() + str.slice(1);
    } catch (e) {
        // Do something - currently stops from bugging out
    }
}

export function getTitleFromSummary(str) {
    try {
        const lines = str.split('\n');
        for (const line of lines) {
            const match = line.match(/^# (.+)/); // Match H1 heading
            const match_lower = line.match(/^## (.+)/)
            if (match) {
                return match[1].trim();
            } else if(match_lower) {
                return match_lower[1].trim();
            }
        }
    } catch (e) {
        // Do something - currently stops from bugging out
    }
}

export function getFormattedDateUTC(dateValue) {
    const date = new Date(dateValue);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${month}-${day}-${year}`;

}